import React from "react";
import CertificadoEnProgreso from "./components/CertificadoEnProgreso";
import CertificadoListo from "./components/CertificadoListo";

export default function ModalCertificado({ certificado, datosCurso, onClose }) {
  return (
    <>
      {certificado === true ? (
        <CertificadoListo datosCurso={datosCurso} onClose={onClose} />
      ) : (
        <CertificadoEnProgreso datosCurso={datosCurso} onClose={onClose} />
      )}
    </>
  );
}
